import providerMethods from './providerMethods';
import Helper from '../utilities/helper';
import ProviderFetch from './providerFetch';
import authenticationProvider from '../utilities/authentication/authenticationProvider';
import {getItemWithExpiry} from '../utilities/localStorageUtils';
import {getRecaptchaToken} from '../utilities/recaptcha/recaptcha';

const throwAboutOnlineViolationInProduction = (funcObj) => {
  if (process.env.NODE_ENV === 'production') {
    const err = `Error in getProviderData funcObj: ${funcObj} online can't be true in production !!`;
    console.error(err);
    throw `${err}`;
  }
};

class ProviderManager {
  static async getProviderData(funcName, parameters) {
    try {
      let funcObj = Object.assign({}, providerMethods[funcName]);
      let token = null;
      token = authenticationProvider.getSavedToken(); // Change later to work with store.
      if (token) {
        if (funcObj.endPointContext?.AUTHENTICATED) {
          if (funcObj.endPointContext.AUTHENTICATED.apiSuffixName) {
            funcObj.apiSuffixName = funcObj.endPointContext.AUTHENTICATED.apiSuffixName;
          }
        }
      } else {
        //ANONYMOUS
        if (funcObj.endPointContext?.ANONYMOUS) {
          if (funcObj.endPointContext.ANONYMOUS.apiSuffixName) {
            funcObj.apiSuffixName = funcObj.endPointContext.ANONYMOUS.apiSuffixName;
          }
        }
      }
      if (funcObj.requiredLogin && !token) {
        // check token exists
        // redirect to login
        authenticationProvider.redirectToLogin(location.pathname, location.pathname, Helper.getLoginTemplate());
      }

      if (funcObj.enableRecaptcha) {
        const recaptchaToken = await getRecaptchaToken(funcObj.apiSuffixName);
        funcObj.headers = Helper.addHeaderParames([{key: 'x-cell-recaptcha-token', value: recaptchaToken}], funcObj.headers);
      }

      let dealerItem = getItemWithExpiry('dealerCode');
      if (dealerItem != undefined) {
        funcObj.headers = Helper.addHeaderParames([{key: 'x-cell-dealer-code', value: dealerItem}], funcObj.headers);
      }

      let customerTrackingItem = getItemWithExpiry('trackingId');
      if (customerTrackingItem != undefined) {
        funcObj.headers = Helper.addHeaderParames([{key: 'x-cell-tracking-id', value: customerTrackingItem}], funcObj.headers);
      }

      if (!funcObj.online) {
        throwAboutOnlineViolationInProduction(funcObj);
        const dynamicImport = await import('./providerOfflineResponse');
        const ProviderOfflineResponse = dynamicImport.default;
        let result = JSON.parse(
          Helper.removeNamespace(
            JSON.stringify(
              await ProviderOfflineResponse.getOfflineResponse().then((res) => {
                return res[funcName].default;
              }),
            ),
          ),
        );
        if (result.Header) {
          let errorCode = result.Header.ReturnCode;
          let returnCodeMessage = result.Header.ReturnCodeMessage;
          if (errorCode === '00') return result;
          else return Promise.reject(returnCodeMessage);
        } else {
          return result;
        }
      } else {
        const isJson = funcObj.httpMethod.toUpperCase() == 'PUT' || funcObj.httpMethod.toUpperCase() == 'POST';
        let funcStringParams = Helper.getFunctionParamsString(funcObj.getArgumentName, parameters, isJson);

        return await ProviderFetch.get(funcObj, funcStringParams, token)
          .then((result) => {
            let errorCode = result.Header?.ReturnCode;
            let returnCodeMessage = result.Header?.ReturnCodeMessage;
            if (errorCode == 0) return result;
            else return Promise.reject({returnCodeMessage, errorCode});
          })
          .catch((error) => {
            return Promise.reject(error);
          });
      }
    } catch (error) {
      return Promise.reject(error);
    }
  }

  static async getProviderDataExtended(funcName, parameters, dymanicHeaderParams) {
    try {
      let funcObj = Object.assign({}, providerMethods[funcName]);

      funcObj.headers = Helper.addHeaderParames(dymanicHeaderParams, funcObj.headers);

      let dealerItem = getItemWithExpiry('dealerCode');
      if (dealerItem != undefined) {
        funcObj.headers = Helper.addHeaderParames([{key: 'x-cell-dealer-code', value: dealerItem}], funcObj.headers);
      }

      let customerTrackingItem = getItemWithExpiry('trackingId');
      if (customerTrackingItem != undefined) {
        funcObj.headers = Helper.addHeaderParames([{key: 'x-cell-tracking-id', value: customerTrackingItem}], funcObj.headers);
      }

      //to do Helper.getFunctionHeaderParams
      let funcStringParams = Helper.getFunctionParamsString(funcObj.getArgumentName, parameters, funcObj.isJsonRequest);

      if (funcObj.requiredLogin) {
        // check token exists
        var token = authenticationProvider.getSavedToken();
        if (!token) {
          // redirect to login
          authenticationProvider.redirectToLogin(location.pathname, location.pathname, Helper.getLoginTemplate());
        }
      }
      if (!funcObj.online) {
        throwAboutOnlineViolationInProduction(funcObj);
        const dynamicImport = await import('./providerOfflineResponse');
        const ProviderOfflineResponse = dynamicImport.default;
        let result = JSON.parse(
          Helper.removeNamespace(
            JSON.stringify(
              await ProviderOfflineResponse.getOfflineResponse().then((res) => {
                return res[funcName].default;
              }),
            ),
          ),
        );
        if (result.Header) {
          let errorCode = result.Header.ReturnCode;
          let returnCodeMessage = result.Header.ReturnCodeMessage;
          if (errorCode == '00') return result;
          else return Promise.reject(returnCodeMessage);
        } else {
          return result;
        }
      } else {
        return await ProviderFetch.get(funcObj, funcStringParams)
          .then((result) => {
            let errorCode = result.Header?.ReturnCode;
            let returnCodeMessage = result.Header?.ReturnCodeMessage;
            if (errorCode == 0) return result;
            else return Promise.reject({returnCodeMessage, errorCode});
          })
          .catch((error) => {
            return Promise.reject(error);
          });
      }
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default ProviderManager;
